import ConfirmEMail from '../../components/auth/confirm-email/ConfirmEMail';
import ForgotPassword from '../../components/auth/forgot-password/ForgotPassword';
import Login from '../../components/auth/login/Login';
import Register from '../../components/auth/registration/Register';
import SaveNewPassword from '../../components/auth/save-new-password/SaveNewPassword';
import { AuthenticationRoute, PrivateRoute } from '../../components/routes/Routes';
import MeineAntraege from '../../pages/private/meine-antraege/MeineAntraege';
import MeinBereich from '../../pages/private/mein-bereich/MeinBereich';
import MeinProfil from '../../pages/private/mein-profil/MeinProfil';
import MeineOrganisation from '../../pages/private/meine-organisation/MeineOrganisation';
import MeineNachrichten from '../../pages/private/meine-nachrichten/MeineNachrichten';
import Faq from '../../pages/public/faq/Faq';
import HomePage from '../../pages/public/homepage/HomePage';
import FoerderProgrammDetails from '../../pages/public/programms/Details/FoerderProgrammDetail';
import FoerderProgrammeView from '../../pages/public/programms/View/FoerderProgrammeView';
import OnlineAntrag from '../../pages/private/online-antrag/OnlineAntrag';
import React from 'react';
import NachrichtenDetails from '../../pages/private/meine-nachrichten/nachrichten-details/NachrichtenDetails';
import FoerderungUebersicht from '../../pages/private/foerderung-uebersicht/FoerderungUebersicht';
import Impressum from '../../pages/public/impressum/Impressum';
import Datenschutz from '../../pages/public/datenschutz/Datenschutz';
import Kontakt from '../../pages/public/kontakt/Kontakt';

export const PUBLIC_PAGES = [
	{ display: 'true', url: '/', name: 'Startseite', element: <HomePage /> },
	{ display: 'true', url: '/foerderprogramm', name: 'Förderprogramme', element: <FoerderProgrammeView /> },
	{
		display: 'false',
		url: '/foerderprogramm/details/:id',
		name: 'Förderprogramme Details',
		element: <FoerderProgrammDetails />,
	},
	{ display: 'true', url: '/faq', name: 'Häufig gestellte Fragen', element: <Faq /> },
	{ display: 'false', url: '/impressum', name: 'Impressum', element: <Impressum /> },
	{ display: 'false', url: '/datenschutz', name: 'Datenschutz', element: <Datenschutz /> },
	{ display: 'false', url: '/kontakt', name: 'Kontakt', element: <Kontakt /> },
];
export const AUTHENTICATION_PAGES = [
	{ url: '/login', name: 'Login', element: <AuthenticationRoute element={<Login />} /> },
	{ url: '/registrierung', name: 'Registrierung', element: <AuthenticationRoute element={<Register />} /> },
	{ url: '/e-mail-bestaetigen', name: 'E-Mail-Adresse bestätigen', element: <AuthenticationRoute element={<ConfirmEMail />} /> },
	{ url: '/passwort-vergessen', name: 'Passwort vergessen', element: <AuthenticationRoute element={<ForgotPassword />} /> },
	{ url: '/passwort-speichern', name: 'Passwort speichern', element: <AuthenticationRoute element={<SaveNewPassword />} /> },
];
export const PRIVATE_PAGES = [
	{ display: true, url: '/mein-bereich', name: 'Mein Bereich', element: <PrivateRoute element={<MeinBereich />} /> },
	{ display: true, url: '/meine-antraege', name: 'Meine Anträge', element: <PrivateRoute element={<MeineAntraege />} /> },
	{
		display: false,
		url: '/meine-antraege/foerderung-uebersicht/:id',
		name: 'Meine Förderungen',
		element: <PrivateRoute element={<FoerderungUebersicht />} />,
	},
	{
		display: false,
		url: '/meine-antraege/online-antrag/:id',
		name: 'Online Antrag',
		element: <PrivateRoute element={<OnlineAntrag />} />,
	},
	{
		display: true,
		showBadge: true,
		url: '/meine-nachrichten',
		name: 'Nachrichten',
		element: <PrivateRoute element={<MeineNachrichten />} />,
	},
	{
		display: false,
		url: '/meine-nachrichten/nachricht-details/:id',
		name: 'Nachrichten Details',
		element: <PrivateRoute element={<NachrichtenDetails />} />,
	},
];
export const PROFILE_PAGES = [
	{ url: '/mein-bereich/mein-profil', name: 'Mein Profil', element: <PrivateRoute element={<MeinProfil />} /> },
	{
		url: '/mein-bereich/meine-organisation',
		name: 'Meine Organisation',
		element: <PrivateRoute element={<MeineOrganisation />} />,
	},
];
